package tables.organization

import emotion.react.css
import kotlinx.browser.window
import models.CategoryModel
import models.OrgProductModelForWeb
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.table
import react.dom.html.ReactHTML.tbody
import react.dom.html.ReactHTML.td
import react.dom.html.ReactHTML.th
import react.dom.html.ReactHTML.thead
import react.dom.html.ReactHTML.tr
import react.useState
import token
import urlAddress
import web.cssom.*

external interface ViewOrgProps : Props {
    var idOrg: Int
    var onClose: () -> Unit
}

val ViewOrgModal = FC<ViewOrgProps> { props ->

    val (orgProductModelsForWeb, setOrgProductModels) = useState(emptyList<OrgProductModelForWeb>())
    val (listCategories, setListCategories) = useState(emptyList<CategoryModel>())
    var isModalOpenCreate by useState(false)

    fun loadCategories() {
        window.fetch(urlAddress + "api/category?id=0", RequestInit(
            method = "GET",
            headers = Headers().apply {
                append("Authorization", "Bearer $token")
            }
        ))
            .then { response -> response.json() }
            .then { data ->
                val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                    CategoryModel(
                        it.id as? Int ?: 0,
                        it.name as? String ?: "",
                        it.parent as? String ?: "",
                        it.iscategory as? Boolean ?: false,
                        it.isactive as? Boolean ?: false
                    )
                }
                setListCategories(newResultList)
            }
    }

    fun loadOrgProductModels() {
        window.fetch(urlAddress + "api/orgproduct?id=${props.idOrg}", RequestInit(
            method = "GET",
            headers = Headers().apply {
                append("Authorization", "Bearer $token")
            }
        ))
            .then { response -> response.json() }
            .then { data ->
                val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                    OrgProductModelForWeb(
                        it.id as? Int ?: 0,
                        it.productName as? String ?: "",
                        it.category as? String ?: "",
                        it.fo as? String ?: "",
                        it.note as? String ?: ""
                    )
                }
                setOrgProductModels(newResultList)
            }
    }

    if (props.idOrg != 0) {
        if (orgProductModelsForWeb.isEmpty()) {
            loadOrgProductModels()
        }

        div {
            css {
                borderRadius = 10.px
                padding = 20.px
                position = Position.fixed
                top = 50.pct
                left = 50.pct
                transform = translate((-50).pct, (-50).pct)
                backgroundColor = rgb(142, 178, 170)
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center
            }

            div {
                div {
                    css {
                        paddingBottom = 20.px
                        display = Display.flex
                        justifyContent = JustifyContent.end
                    }
                    button {
                        +"Добавить"
                        onClick = {
                            loadCategories()
                            isModalOpenCreate = true
                        }
                    }
                    button {
                        +"❌"
                        onClick = {
                            setOrgProductModels(emptyList())
                            props.onClose()
                        }
                    }
                }
                table {
                    border = 1
                    css {
                        borderColor = Color("#000")
                        borderCollapse = BorderCollapse.collapse
                        textAlign = TextAlign.center
                    }
                    thead {
                        tr {
                            th { +"Наименование" }
                            th { +"Категория" }
                            th { +"ФО" }
                            th { +"Примечание" }
                            th { +"Действие" }
                        }
                    }
                    tbody {
                        orgProductModelsForWeb.forEach { item ->
                            tr {
                                td { +item.productName }
                                td { +item.category }
                                td { +item.fo }
                                td { +item.note }
                                td {
                                    div {
                                        css {
                                            display = Display.flex
                                            flexDirection = FlexDirection.row
                                            alignItems = AlignItems.center
                                            justifyContent = JustifyContent.center
                                        }
                                        button {
                                            css {
                                                margin = 5.px
                                                marginBottom = 5.px
                                                fontSize = 14.px
                                            }
                                            +"✏️"
                                            onClick = {
//                                                    isModalOpenUpdate = item
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        CreateOrgProductModal {
            isOpen = isModalOpenCreate
            idOrg = props.idOrg
            listCategoryModel = listCategories
            onClose = {
                isModalOpenCreate = false
            }
            onUpdate = {
                loadOrgProductModels()
            }
        }
    }
}
